import React from 'react';
import { Box, Typography, TableRow, TableCell } from '@mui/material';
import { acme } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

export const acmeEmptyStateSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  py: { xs: 6, sm: 8 },
  px: { xs: 2, sm: 4 },
  textAlign: 'center',
};

/**
 * Acme empty / zero-data placeholder for tables, lists, and pages.
 */
export default function EmptyState({
  icon: Icon,
  title,
  description,
  hint,
  action,
  sx,
  iconSx,
}) {
  return (
    <Box sx={mergeSx(acmeEmptyStateSx, sx)}>
      {Icon && (
        <Icon
          sx={mergeSx(
            {
              fontSize: 64,
              color: acme.colors.mutedForegroundSolid,
              mb: 2,
              opacity: 0.45,
            },
            iconSx,
          )}
        />
      )}
      {title && (
        <Typography
          variant="h6"
          sx={{ color: acme.colors.foreground, fontWeight: 600, mb: 1 }}
        >
          {title}
        </Typography>
      )}
      {description && (
        <Typography
          variant="body2"
          sx={{
            color: acme.colors.mutedForegroundSolid,
            maxWidth: 480,
            lineHeight: 1.6,
            mb: hint || action ? 1 : 0,
          }}
        >
          {description}
        </Typography>
      )}
      {hint && (
        <Typography
          variant="body2"
          sx={{ color: acme.colors.mutedForegroundSolid, fontStyle: 'italic' }}
        >
          {hint}
        </Typography>
      )}
      {action}
    </Box>
  );
}

export function TableEmptyRow({ colSpan, ...emptyProps }) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} sx={{ border: 'none', p: 0 }}>
        <EmptyState {...emptyProps} />
      </TableCell>
    </TableRow>
  );
}
